/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContentWriteResult,
  IntegrationExecutionOutput,
  ReplayFromRequest,
} from '../models/index';
import {
    ContentWriteResultFromJSON,
    ContentWriteResultToJSON,
    IntegrationExecutionOutputFromJSON,
    IntegrationExecutionOutputToJSON,
    ReplayFromRequestFromJSON,
    ReplayFromRequestToJSON,
} from '../models/index';

export interface CancelExecutionRequest {
    executionId: string;
    sessionId?: string;
}

export interface DownloadCodeBundleRequest {
    executionId: string;
    authorization?: string;
}

export interface GetCrossTenantWritesRequest {
    executionId: string;
    sessionId?: string;
}

export interface GetExecutionRequest {
    executionId: string;
    sessionId?: string;
}

export interface GetExecutionHistoryRequest {
    instanceId: string;
    limit?: number;
    periodType?: string;
    periodValue?: number;
    startDate?: Date;
    endDate?: Date;
    sessionId?: string;
}

export interface GetExecutionStatisticsRequest {
    instanceId: string;
    sessionId?: string;
}

export interface GetExecutionUsageRequest {
    executionId: string;
    sessionId?: string;
}

export interface GetFilteredRecordsRequest {
    executionId: string;
    mappingId?: string;
    filterStage?: string;
    sessionId?: string;
}

export interface GetLoadedRecordsRequest {
    executionId: string;
    sessionId?: string;
    loadOutcome?: string;
}

export interface GetPipelineStagesRequest {
    executionId: string;
    sessionId?: string;
}

export interface GetPipelineSummaryRequest {
    executionId: string;
    sessionId?: string;
}

export interface GetProvenanceEventsRequest {
    executionId: string;
    sessionId?: string;
    eventType?: string;
}

export interface GetRunningExecutionsRequest {
    sessionId?: string;
}

export interface ListPipelineChunksRequest {
    executionId: string;
    sessionId?: string;
}

export interface ListProvenanceEventsRequest {
    from: Date;
    to: Date;
    instanceId?: string;
    tenantId?: string;
    page?: number;
    size?: number;
    sessionId?: string;
}

export interface ReceiveExecutionCallbackRequest {
    executionId: string;
    integrationExecutionOutput: IntegrationExecutionOutput;
    authorization?: string;
}

export interface ReplayFromOperationRequest {
    instanceId: string;
    replayFromRequest: ReplayFromRequest;
    sessionId?: string;
}

export interface SignalWorkflowRequest {
    executionId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface UploadChunkRequest {
    executionId: string;
    chunkId: string;
    body: string;
    xRecordCount?: number;
    authorization?: string;
}

/**
 * IntegrationMarketplaceExecutionsApi - interface
 * 
 * @export
 * @interface IntegrationMarketplaceExecutionsApiInterface
 */
export interface IntegrationMarketplaceExecutionsApiInterface {
    /**
     * Cancel a running integration execution
     * @summary Cancel execution
     * @param {string} executionId Execution ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    cancelExecutionRaw(requestParameters: CancelExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Cancel a running integration execution
     * Cancel execution
     */
    cancelExecution(requestParameters: CancelExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Init container download for kubernetes bundle staging (HMAC token required)
     * @summary Download integration code bundle
     * @param {string} executionId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    downloadCodeBundleRaw(requestParameters: DownloadCodeBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Init container download for kubernetes bundle staging (HMAC token required)
     * Download integration code bundle
     */
    downloadCodeBundle(requestParameters: DownloadCodeBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Per-effect-tenant load counts for hub executions that wrote into child tenants. Hub operators see all targets; effect-tenant sessions see only their tenant rows.
     * @summary Get cross-tenant writes
     * @param {string} executionId Execution ID (workflow ID or entity id)
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getCrossTenantWritesRaw(requestParameters: GetCrossTenantWritesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Per-effect-tenant load counts for hub executions that wrote into child tenants. Hub operators see all targets; effect-tenant sessions see only their tenant rows.
     * Get cross-tenant writes
     */
    getCrossTenantWrites(requestParameters: GetCrossTenantWritesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get detailed information about a specific execution
     * @summary Get execution
     * @param {string} executionId Execution ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getExecutionRaw(requestParameters: GetExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get detailed information about a specific execution
     * Get execution
     */
    getExecution(requestParameters: GetExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get execution history for an integration instance. Supports filtering by reporting period or date range.
     * @summary Get execution history
     * @param {string} instanceId Instance ID
     * @param {number} [limit] Max number of results
     * @param {string} [periodType] Reporting period type (MINUTES, HOURS, DAYS, MONTHS, QUARTERS, ALL_TIME)
     * @param {number} [periodValue] Reporting period value (e.g., 7 for \&#39;Last 7 days\&#39;)
     * @param {Date} [startDate] Start date (ISO-8601 format). Alternative to reporting period.
     * @param {Date} [endDate] End date (ISO-8601 format). Defaults to now if not provided.
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getExecutionHistoryRaw(requestParameters: GetExecutionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get execution history for an integration instance. Supports filtering by reporting period or date range.
     * Get execution history
     */
    getExecutionHistory(requestParameters: GetExecutionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get detailed execution statistics for an integration instance
     * @summary Get execution statistics
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getExecutionStatisticsRaw(requestParameters: GetExecutionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get detailed execution statistics for an integration instance
     * Get execution statistics
     */
    getExecutionStatistics(requestParameters: GetExecutionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Usage (metering) for this execution. Use for drill-down from chain run breakdown.
     * @summary Get execution usage
     * @param {string} executionId Execution ID (workflow ID)
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getExecutionUsageRaw(requestParameters: GetExecutionUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Usage (metering) for this execution. Use for drill-down from chain run breakdown.
     * Get execution usage
     */
    getExecutionUsage(requestParameters: GetExecutionUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * List records excluded by load filter with filter_reason per mapping
     * @summary Get filtered records
     * @param {string} executionId Execution ID (workflow ID or entity id)
     * @param {string} [mappingId] Optional mapping ID filter
     * @param {string} [filterStage] Optional stage filter: INGESTION, LOAD
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getFilteredRecordsRaw(requestParameters: GetFilteredRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List records excluded by load filter with filter_reason per mapping
     * Get filtered records
     */
    getFilteredRecords(requestParameters: GetFilteredRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * List records loaded into MDM source tables for this execution (post-transform data)
     * @summary Get loaded records
     * @param {string} executionId Execution ID (workflow ID or entity id)
     * @param {string} [sessionId] 
     * @param {string} [loadOutcome] Filter by load outcome: created or updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getLoadedRecordsRaw(requestParameters: GetLoadedRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List records loaded into MDM source tables for this execution (post-transform data)
     * Get loaded records
     */
    getLoadedRecords(requestParameters: GetLoadedRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Structured stage-by-stage counts (fetch, rawCapture, transform, load, golden, operational)
     * @summary Get pipeline stages
     * @param {string} executionId Execution ID (workflow ID or entity id)
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getPipelineStagesRaw(requestParameters: GetPipelineStagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Structured stage-by-stage counts (fetch, rawCapture, transform, load, golden, operational)
     * Get pipeline stages
     */
    getPipelineStages(requestParameters: GetPipelineStagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Per-stage chunk queue summary for chunked executions
     * @summary Get pipeline chunk summary
     * @param {string} executionId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getPipelineSummaryRaw(requestParameters: GetPipelineSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Per-stage chunk queue summary for chunked executions
     * Get pipeline chunk summary
     */
    getPipelineSummary(requestParameters: GetPipelineSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * List fine-grained pipeline events for an execution
     * @summary Get provenance events
     * @param {string} executionId Execution ID (workflow ID or entity id)
     * @param {string} [sessionId] 
     * @param {string} [eventType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getProvenanceEventsRaw(requestParameters: GetProvenanceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List fine-grained pipeline events for an execution
     * Get provenance events
     */
    getProvenanceEvents(requestParameters: GetProvenanceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Lists all currently running integration executions
     * @summary Get running executions
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    getRunningExecutionsRaw(requestParameters: GetRunningExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists all currently running integration executions
     * Get running executions
     */
    getRunningExecutions(requestParameters: GetRunningExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary List pipeline chunk queue items with content refs
     * @param {string} executionId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    listPipelineChunksRaw(requestParameters: ListPipelineChunksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List pipeline chunk queue items with content refs
     */
    listPipelineChunks(requestParameters: ListPipelineChunksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * List pipeline events by tenant or instance and time range (paginated)
     * @summary List provenance events
     * @param {Date} from Start of time range (ISO-8601)
     * @param {Date} to End of time range (ISO-8601)
     * @param {string} [instanceId] Instance ID (optional; if set, filter by instance)
     * @param {string} [tenantId] Tenant ID (optional; used when instanceId not set)
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    listProvenanceEventsRaw(requestParameters: ListProvenanceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List pipeline events by tenant or instance and time range (paginated)
     * List provenance events
     */
    listProvenanceEvents(requestParameters: ListProvenanceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Receive execution result from integration container (alternative to stdout parsing)
     * @summary Receive execution callback
     * @param {string} executionId Execution ID (workflow ID)
     * @param {IntegrationExecutionOutput} integrationExecutionOutput 
     * @param {string} [authorization] Callback token for authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    receiveExecutionCallbackRaw(requestParameters: ReceiveExecutionCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Receive execution result from integration container (alternative to stdout parsing)
     * Receive execution callback
     */
    receiveExecutionCallback(requestParameters: ReceiveExecutionCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Start a new execution that replays from TRANSFORM or LOAD using provenance refs from the given source execution
     * @summary Replay from step
     * @param {string} instanceId Integration instance ID
     * @param {ReplayFromRequest} replayFromRequest 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    replayFromRaw(requestParameters: ReplayFromOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Start a new execution that replays from TRANSFORM or LOAD using provenance refs from the given source execution
     * Replay from step
     */
    replayFrom(requestParameters: ReplayFromOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Send a signal to a running workflow (e.g. Approval with payload { \"approved\": true })
     * @summary Signal workflow
     * @param {string} executionId Execution ID (workflow ID)
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    signalWorkflowRaw(requestParameters: SignalWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Send a signal to a running workflow (e.g. Approval with payload { \"approved\": true })
     * Signal workflow
     */
    signalWorkflow(requestParameters: SignalWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Upload a chunk of fetched data for chunked mode. Uses same callback token as execution callback.
     * @summary Upload execution chunk
     * @param {string} executionId Execution ID (workflow ID)
     * @param {string} chunkId Chunk identifier within this execution (e.g. 0, 1, 2)
     * @param {string} body 
     * @param {number} [xRecordCount] Optional record count for this chunk
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceExecutionsApiInterface
     */
    uploadChunkRaw(requestParameters: UploadChunkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentWriteResult>>;

    /**
     * Upload a chunk of fetched data for chunked mode. Uses same callback token as execution callback.
     * Upload execution chunk
     */
    uploadChunk(requestParameters: UploadChunkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentWriteResult>;

}

/**
 * 
 */
export class IntegrationMarketplaceExecutionsApi extends runtime.BaseAPI implements IntegrationMarketplaceExecutionsApiInterface {

    /**
     * Cancel a running integration execution
     * Cancel execution
     */
    async cancelExecutionRaw(requestParameters: CancelExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling cancelExecution().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/{executionId}/cancel`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Cancel a running integration execution
     * Cancel execution
     */
    async cancelExecution(requestParameters: CancelExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.cancelExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Init container download for kubernetes bundle staging (HMAC token required)
     * Download integration code bundle
     */
    async downloadCodeBundleRaw(requestParameters: DownloadCodeBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling downloadCodeBundle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['authorization'] != null) {
            headerParameters['Authorization'] = String(requestParameters['authorization']);
        }


        let urlPath = `/v1/marketplace/executions/{executionId}/code-bundle`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Init container download for kubernetes bundle staging (HMAC token required)
     * Download integration code bundle
     */
    async downloadCodeBundle(requestParameters: DownloadCodeBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.downloadCodeBundleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Per-effect-tenant load counts for hub executions that wrote into child tenants. Hub operators see all targets; effect-tenant sessions see only their tenant rows.
     * Get cross-tenant writes
     */
    async getCrossTenantWritesRaw(requestParameters: GetCrossTenantWritesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling getCrossTenantWrites().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/{executionId}/cross-tenant-writes`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Per-effect-tenant load counts for hub executions that wrote into child tenants. Hub operators see all targets; effect-tenant sessions see only their tenant rows.
     * Get cross-tenant writes
     */
    async getCrossTenantWrites(requestParameters: GetCrossTenantWritesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCrossTenantWritesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about a specific execution
     * Get execution
     */
    async getExecutionRaw(requestParameters: GetExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling getExecution().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/{executionId}`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get detailed information about a specific execution
     * Get execution
     */
    async getExecution(requestParameters: GetExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get execution history for an integration instance. Supports filtering by reporting period or date range.
     * Get execution history
     */
    async getExecutionHistoryRaw(requestParameters: GetExecutionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getExecutionHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['periodType'] != null) {
            queryParameters['periodType'] = requestParameters['periodType'];
        }

        if (requestParameters['periodValue'] != null) {
            queryParameters['periodValue'] = requestParameters['periodValue'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/instance/{instanceId}`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get execution history for an integration instance. Supports filtering by reporting period or date range.
     * Get execution history
     */
    async getExecutionHistory(requestParameters: GetExecutionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getExecutionHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed execution statistics for an integration instance
     * Get execution statistics
     */
    async getExecutionStatisticsRaw(requestParameters: GetExecutionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getExecutionStatistics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/instance/{instanceId}/statistics`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get detailed execution statistics for an integration instance
     * Get execution statistics
     */
    async getExecutionStatistics(requestParameters: GetExecutionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getExecutionStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Usage (metering) for this execution. Use for drill-down from chain run breakdown.
     * Get execution usage
     */
    async getExecutionUsageRaw(requestParameters: GetExecutionUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling getExecutionUsage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/{executionId}/usage`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Usage (metering) for this execution. Use for drill-down from chain run breakdown.
     * Get execution usage
     */
    async getExecutionUsage(requestParameters: GetExecutionUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getExecutionUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List records excluded by load filter with filter_reason per mapping
     * Get filtered records
     */
    async getFilteredRecordsRaw(requestParameters: GetFilteredRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling getFilteredRecords().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['mappingId'] != null) {
            queryParameters['mappingId'] = requestParameters['mappingId'];
        }

        if (requestParameters['filterStage'] != null) {
            queryParameters['filterStage'] = requestParameters['filterStage'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/{executionId}/filtered-records`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List records excluded by load filter with filter_reason per mapping
     * Get filtered records
     */
    async getFilteredRecords(requestParameters: GetFilteredRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getFilteredRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List records loaded into MDM source tables for this execution (post-transform data)
     * Get loaded records
     */
    async getLoadedRecordsRaw(requestParameters: GetLoadedRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling getLoadedRecords().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['loadOutcome'] != null) {
            queryParameters['loadOutcome'] = requestParameters['loadOutcome'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/{executionId}/loaded-records`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List records loaded into MDM source tables for this execution (post-transform data)
     * Get loaded records
     */
    async getLoadedRecords(requestParameters: GetLoadedRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getLoadedRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Structured stage-by-stage counts (fetch, rawCapture, transform, load, golden, operational)
     * Get pipeline stages
     */
    async getPipelineStagesRaw(requestParameters: GetPipelineStagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling getPipelineStages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/{executionId}/pipeline-stages`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Structured stage-by-stage counts (fetch, rawCapture, transform, load, golden, operational)
     * Get pipeline stages
     */
    async getPipelineStages(requestParameters: GetPipelineStagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getPipelineStagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Per-stage chunk queue summary for chunked executions
     * Get pipeline chunk summary
     */
    async getPipelineSummaryRaw(requestParameters: GetPipelineSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling getPipelineSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/{executionId}/pipeline-summary`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Per-stage chunk queue summary for chunked executions
     * Get pipeline chunk summary
     */
    async getPipelineSummary(requestParameters: GetPipelineSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getPipelineSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List fine-grained pipeline events for an execution
     * Get provenance events
     */
    async getProvenanceEventsRaw(requestParameters: GetProvenanceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling getProvenanceEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['eventType'] != null) {
            queryParameters['eventType'] = requestParameters['eventType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/{executionId}/provenance-events`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List fine-grained pipeline events for an execution
     * Get provenance events
     */
    async getProvenanceEvents(requestParameters: GetProvenanceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getProvenanceEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all currently running integration executions
     * Get running executions
     */
    async getRunningExecutionsRaw(requestParameters: GetRunningExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/running`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists all currently running integration executions
     * Get running executions
     */
    async getRunningExecutions(requestParameters: GetRunningExecutionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRunningExecutionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List pipeline chunk queue items with content refs
     */
    async listPipelineChunksRaw(requestParameters: ListPipelineChunksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling listPipelineChunks().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/{executionId}/pipeline-chunks`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List pipeline chunk queue items with content refs
     */
    async listPipelineChunks(requestParameters: ListPipelineChunksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listPipelineChunksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List pipeline events by tenant or instance and time range (paginated)
     * List provenance events
     */
    async listProvenanceEventsRaw(requestParameters: ListProvenanceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['from'] == null) {
            throw new runtime.RequiredError(
                'from',
                'Required parameter "from" was null or undefined when calling listProvenanceEvents().'
            );
        }

        if (requestParameters['to'] == null) {
            throw new runtime.RequiredError(
                'to',
                'Required parameter "to" was null or undefined when calling listProvenanceEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString();
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = (requestParameters['to'] as any).toISOString();
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/executions/provenance`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List pipeline events by tenant or instance and time range (paginated)
     * List provenance events
     */
    async listProvenanceEvents(requestParameters: ListProvenanceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listProvenanceEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Receive execution result from integration container (alternative to stdout parsing)
     * Receive execution callback
     */
    async receiveExecutionCallbackRaw(requestParameters: ReceiveExecutionCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling receiveExecutionCallback().'
            );
        }

        if (requestParameters['integrationExecutionOutput'] == null) {
            throw new runtime.RequiredError(
                'integrationExecutionOutput',
                'Required parameter "integrationExecutionOutput" was null or undefined when calling receiveExecutionCallback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['authorization'] != null) {
            headerParameters['Authorization'] = String(requestParameters['authorization']);
        }


        let urlPath = `/v1/marketplace/executions/{executionId}/callback`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationExecutionOutputToJSON(requestParameters['integrationExecutionOutput']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Receive execution result from integration container (alternative to stdout parsing)
     * Receive execution callback
     */
    async receiveExecutionCallback(requestParameters: ReceiveExecutionCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.receiveExecutionCallbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start a new execution that replays from TRANSFORM or LOAD using provenance refs from the given source execution
     * Replay from step
     */
    async replayFromRaw(requestParameters: ReplayFromOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling replayFrom().'
            );
        }

        if (requestParameters['replayFromRequest'] == null) {
            throw new runtime.RequiredError(
                'replayFromRequest',
                'Required parameter "replayFromRequest" was null or undefined when calling replayFrom().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/executions/instance/{instanceId}/replay-from`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReplayFromRequestToJSON(requestParameters['replayFromRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Start a new execution that replays from TRANSFORM or LOAD using provenance refs from the given source execution
     * Replay from step
     */
    async replayFrom(requestParameters: ReplayFromOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.replayFromRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a signal to a running workflow (e.g. Approval with payload { \"approved\": true })
     * Signal workflow
     */
    async signalWorkflowRaw(requestParameters: SignalWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling signalWorkflow().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling signalWorkflow().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/executions/{executionId}/signal`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Send a signal to a running workflow (e.g. Approval with payload { \"approved\": true })
     * Signal workflow
     */
    async signalWorkflow(requestParameters: SignalWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.signalWorkflowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a chunk of fetched data for chunked mode. Uses same callback token as execution callback.
     * Upload execution chunk
     */
    async uploadChunkRaw(requestParameters: UploadChunkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentWriteResult>> {
        if (requestParameters['executionId'] == null) {
            throw new runtime.RequiredError(
                'executionId',
                'Required parameter "executionId" was null or undefined when calling uploadChunk().'
            );
        }

        if (requestParameters['chunkId'] == null) {
            throw new runtime.RequiredError(
                'chunkId',
                'Required parameter "chunkId" was null or undefined when calling uploadChunk().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling uploadChunk().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['chunkId'] != null) {
            queryParameters['chunkId'] = requestParameters['chunkId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRecordCount'] != null) {
            headerParameters['X-Record-Count'] = String(requestParameters['xRecordCount']);
        }

        if (requestParameters['authorization'] != null) {
            headerParameters['Authorization'] = String(requestParameters['authorization']);
        }


        let urlPath = `/v1/marketplace/executions/{executionId}/chunks`;
        urlPath = urlPath.replace(`{${"executionId"}}`, encodeURIComponent(String(requestParameters['executionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentWriteResultFromJSON(jsonValue));
    }

    /**
     * Upload a chunk of fetched data for chunked mode. Uses same callback token as execution callback.
     * Upload execution chunk
     */
    async uploadChunk(requestParameters: UploadChunkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentWriteResult> {
        const response = await this.uploadChunkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
